module.exports = __webpack_public_path__ + "img/fundadores.109bdbf1.png";